export const columnData = {
  Delete: { name: 'Eliminar', widthCol: '10%' },
  Code: { name: 'Costo', widthCol: '10%' },
  Name: { name: 'Beneficio', widthCol: '25%' },
  FrecuencyName: { name: 'Frecuencia pago', widthCol: '30%' },
  Description: { name: 'Descripción', widthCol: '30%' },
  Edit: { name: 'Editar', widthCol: '10%' }
}
